import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { RxCheck, RxMinus } from 'react-icons/rx/index';
const enabledColor = '#1677ff';
const disabledColor = '#b8b8b8';
export function Checkbox(props) {
    const { checked = 'indeterminate', disabled = false, label, onChange, } = props;
    return (_jsxs("label", { style: {
            display: 'flex',
            alignItems: 'center',
            fontSize: '1.125em',
        }, children: [_jsx(RadixCheckbox.Root, { checked: checked, onCheckedChange: onChange, disabled: disabled, css: css({
                    width: '16px',
                    height: '16px',
                    backgroundColor: disabled
                        ? 'rgba(0, 0, 0, 0.04)'
                        : checked
                            ? enabledColor
                            : 'white',
                    borderWidth: '1px',
                    borderColor: checked && !disabled ? enabledColor : disabledColor,
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                }), children: _jsx(RadixCheckbox.Indicator, { css: css({
                        color: disabled ? disabledColor : 'white',
                    }), children: checked === true ? (_jsx(RxCheck, {})) : checked === 'indeterminate' ? (_jsx(RxMinus, {})) : null }) }), _jsx("span", { style: {
                    paddingInline: '8px',
                    lineHeight: '16px',
                }, children: label })] }));
}
//# sourceMappingURL=Checkbox.js.map